import { createSelector } from '@ngrx/store';
import { AppState } from '../core.reducers';

export const selectFilters = (state: AppState) => state.filters;

export const search = createSelector(selectFilters, (state) => state.search);
